import axios from 'axios';

export const listAllLanguagesService = async () => {
    try {
        return await axios.get(`${process.env.REACT_APP_API_URL}/api/language/list_all`)
            .then((response) => response?.data)
            .catch((error) => {
                console.log(error);
                return false;
            });
    } catch (error) {
        return false;
    }
};
